module.exports = __webpack_public_path__ + "static/media/liquidity-remove.786ee337.svg";